import React, { Component, createRef } from 'react';
import { isMobile, isEdge, isIOS, isSafari } from 'react-device-detect';
import classes from './Radio.module.css';

export default class Radio extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fontSize: '0.75rem',
    };
    this.divElement = createRef();
  }

  componentDidMount() {
    // console.log('Radio.js componentDidMount');
    this._updateFontSize();
    window.addEventListener('resize', this._updateFontSize);
  }

  componentDidUpdate(prevProps) {
    // console.log('Radio.js componentDidUpdate');
    if (
      prevProps.isLandscape !== this.props.isLandscape ||
      prevProps.largerRadio !== this.props.largerRadio
    ) {
      this._updateFontSize();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this._updateFontSize);
  }

  _getTextWidth = (text, font) => {
    const canvas =
      this._getTextWidth.canvas ||
      (this._getTextWidth.canvas = document.createElement('canvas'));
    const context = canvas.getContext('2d');
    context.font = font;
    return context.measureText(text).width;
  };

  _calculateFontSize = () => {
    if (!this.divElement.current) {
      return '0.75rem';
    }

    const width = this.divElement.current.clientWidth;
    const textWidth = this._getTextWidth(
      this.props.longestText,
      this.props.isLandscape ? '400 0.625rem Helvetica' : '400 0.5rem Helvetica'
    );

    const calcRatio = isMobile || !this.props.isLandscape ? 0.35 : 0.425;
    const calcFontSize = (width / textWidth) * calcRatio;

    let minFontSize = this.props.isLandscape
      ? this.props.largerRadio
        ? '0.625rem'
        : '0.75rem'
      : this.props.largerRadio
      ? '0.5rem'
      : '0.625rem';

    if (
      isEdge ||
      (isIOS && !this.props.isLandscape) ||
      (isSafari && this.props.isLandscape)
    ) {
      return minFontSize;
    } else if (!this.props.isLandscape && calcFontSize > 1) {
      return '1rem';
    } else if (calcFontSize > 1.5) {
      return '1.45rem';
    } else if (calcFontSize > 0.63) {
      return `${Math.round(calcFontSize * 1000) / 1000}rem`;
    } else {
      return minFontSize;
    }
  };

  _updateFontSize = () => {
    this.setState({ fontSize: this._calculateFontSize() });
  };

  render() {
    const RadioWrapper = this.props.largerRadio
      ? classes.RadioWrapper
      : classes.RadioWrapperLarger;

    return (
      <div ref={this.divElement}>
        <div className={RadioWrapper} onClick={this.props.radioClicked}>
          <div
            className={
              this.props.selected
                ? [classes.RadioCircle, classes.RadioCircleSelected].join(' ')
                : classes.RadioCircle
            }
          >
            <div
              className={classes.OptionNames}
              style={{ fontSize: this.state.fontSize }}
            >
              {this.props.optionText}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
